import React, { useState, useMemo, useRef } from 'react';
import TinderCard from 'react-tinder-card';
import ActionBtn from '../ActionBtn';
import { downAction, upAction } from '../../utils/actionFun';
import ImageSlider from '../ImageSlider';

const Swipe = ({ products, currentIndex, setCurrentIndex, setCartProductsList, cartProductsList, productId, setProductId, setCaption, caption, productInfo, wishList, setWishList }) => {

    const [loadingStates, setLoadingStates] = useState({});

    const setProductLoading = (productId, isLoading) => {
        setLoadingStates(prevState => ({
            ...prevState,
            [productId]: isLoading
        }));
    };

    const childRefs = useMemo(
        () =>
            Array(products?.length)
                .fill(0).map(i => React.createRef()),
        [products?.length]
    )

    // used for outOfFrame closure
    const currentIndexRef = useRef(currentIndex);

    const updateCurrentIndex = (val) => {
        setCurrentIndex(val);
        currentIndexRef.current = val;
    }

    // set last direction and decrease current index
    const swiped = async (direction, nameToDelete, index, id) => {
        childRefs[index].swipedTo = direction;
        if (direction === "left" && index < products.length - 1 && childRefs[index + 1].swipedTo === 'right') {
            childRefs[index + 1].current?.restoreCard();
        } else if (direction === "right" && index > 0 && childRefs[index - 1].swipedTo === 'left') {
            childRefs[index - 1].current?.restoreCard();
        }

        updateCurrentIndex(index - 1);
        // setProductId(products[index - 1]?.id || products[products?.length - 1]?.id);
        if (index === 0) {
            childRefs.map(ref => ref.current?.restoreCard())

            setTimeout(() => {
                childRefs[index].current?.restoreCard();
            }, 100);
        }

        if (direction === "down") {
            downAction(id, setCartProductsList, cartProductsList, productId, setProductLoading);
        }

        else if (direction === "up") {
            upAction(wishList, id, setWishList);
        }
    }

    const outOfFrame = (name, index) => {
        // handle the case in which go back is pressed before card goes outOfFrame
        currentIndexRef.current >= index && childRefs[index].current.restoreCard()

        const singleEls = document.querySelectorAll('.cardContainer .single');
        let currentIds = [];
        singleEls.forEach(singleEl => {
            const transformCSS = singleEl.children[0].style.transform;
            if (transformCSS === 'translate3d(0px, 0px, 0px) rotate(0deg)') {
                currentIds.push(singleEl.children[0].children[0].id);
            }
        })
        setProductId(parseInt(currentIds[currentIds.length - 1]));
    }

    const actionBtnProps = {
        productId,
        cartCount: cartProductsList?.reduce((total, product) => total + parseInt(product.quantity), 0),
        cartProductsList,
        setCartProductsList,
        totalWishList: wishList?.length,
        wishList,
        setWishList,
        setCaption
    }
    return <>
        {products?.map((product, index) => {

            return <div key={index} className='single'>
                <TinderCard ref={childRefs[index]} className='swipe' key={product?.name}
                    onSwipe={(dir) => swiped(dir, product?.name, index, product?.id)}
                    onCardLeftScreen={() => outOfFrame(product?.name, index)}
                    flickOnSwipe={true}
                    swipeRequirementType={"position"}
                    swipeThreshold={100}
                    preventSwipe={index === products.length - 1 ? ['left'] : []}
                >
                    <div id={product?.id} className={`card card-${index}`} >
                        <div className="main">
                            <div className={`title ${caption === 'title' ? '' : 'hidden'}`}>{productInfo?.name.length > 50 ? productInfo?.name.slice(0, 50) + '...' : productInfo?.name}</div>

                            <div className={`desc ${caption === 'description' ? '' : 'hidden'}`}>{product.desc.length > 120 ? product.desc.slice(0, 120) + '...' : product.desc}</div>
                        </div>
                        <ImageSlider product={product} />
                    </div>
                    {/* <span >{index}</span> */}
                </TinderCard>
            </div>
        })}
        <ActionBtn {...actionBtnProps} />
    </>
}
export default Swipe;